import type { Event } from '@ori-events/toggle-menu-flyout';
import { Name } from '@ori-events/toggle-menu-flyout';
import { useEffect } from 'react';

import { useActiveMenu } from '../context/navigation/activeMenuContext';

declare global {
  interface WindowEventMap {
    [Name]: Event;
  }
}

export const useToggleMenuHandler = () => {
  const { toggleActiveMenu } = useActiveMenu();
  useEffect(() => {
    const onToggle = (event: Event) => toggleActiveMenu(event.detail.menuType);
    window.addEventListener(Name, onToggle);

    return () => window.removeEventListener(Name, onToggle);
  }, [toggleActiveMenu]);
};
